import { render, staticRenderFns } from "./ValidateTab.vue?vue&type=template&id=5edf9f26&scoped=true&"
import script from "./ValidateTab.vue?vue&type=script&lang=js&"
export * from "./ValidateTab.vue?vue&type=script&lang=js&"
import style0 from "./ValidateTab.vue?vue&type=style&index=0&id=5edf9f26&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf9f26",
  null
  
)

export default component.exports